import { type GridPaginationModel } from "@mui/x-data-grid"
import { useSearchParams } from "react-router-dom"

const DEFAULT_PAGE_SIZE = 50

const parsePositiveInt = (value: string | null): number | undefined => {
  if (!value) return undefined
  const parsed = Number.parseInt(value, 10)
  return Number.isInteger(parsed) && parsed > 0 ? parsed : undefined
}

export function useUrlPaginationModel(defaultPageSize = DEFAULT_PAGE_SIZE) {
  const [searchParams, setSearchParams] = useSearchParams()

  const page = (parsePositiveInt(searchParams.get("page")) ?? 1) - 1
  const pageSize =
    parsePositiveInt(searchParams.get("pageSize")) ?? defaultPageSize
  const paginationModel: GridPaginationModel = { page, pageSize }

  const onPaginationModelChange = (model: GridPaginationModel) => {
    setSearchParams(
      (params) => {
        params.set("page", String(model.page + 1))
        params.set("pageSize", String(model.pageSize))
        return params
      },
      { replace: true },
    )
  }

  return { paginationModel, onPaginationModelChange }
}
